import React from 'react';
import { useParams } from 'react-router-dom';
import { Logs } from 'components/common/logs';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';

export const TaskLogs = React.memo(() => {
  const { taskId } = useParams() as { taskId: string };
  return (
    <HasAccess role={PERMISSIONS.tasks.logs.read}>
      <div className={'logs-layout-task-container'}>
        <Logs entityName={'TASK'} id={taskId} />
      </div>
    </HasAccess>
  );
});
